/* -------------------------------------------------------------------------- */
/*                                dependencies                                */
/* -------------------------------------------------------------------------- */
// Packages
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// Local UI components
import TabsNavbar from "../Components/Common/TabsNavBar/TabsNavbar";
import CommandesViewTabsContent from "../Components/Commandes/CommandesViewTabsContent";
import CommandesTabContent from "../Components/Commandes/CommandesTabContent";
import { fetchCommandes } from "../REDUX/actions/commandes";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const CommandesView = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(location.state?.view || "Orders");
  const { userRole, user } = useSelector((state) => state.userReducer);
  const isAdmin = userRole === "admin";

  useEffect(() => {
    const controller = new AbortController();
    if (user) {
      dispatch(
        fetchCommandes(
          undefined,
          undefined,
          undefined,
          1,
          undefined,
          controller.signal,
        ),
      );
    }
    return () => controller.abort();
  }, [dispatch, user.id]);

  return (
    <div className="w100 d-flex flex-column gap-4 h-100">
      {!isAdmin ? (
        <CommandesTabContent activeTab={activeTab} />
      ) : (
        <>
          <TabsNavbar
            tabs={["Orders", "Credits", "Invoices"]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            className="gap-5"
          />
          <CommandesViewTabsContent activeTab={activeTab} />
        </>
      )}
    </div>
  );
};

export default CommandesView;
